import { useState } from "react";
import { Link } from "react-router-dom";
import { PROJECTS } from "../lib/data";
import ScrollReveal from "../components/ScrollReveal";

const FILTERS = ["All", "Branding", "UI/UX", "Content", "EdTech"];

// Trusted clients list
const CLIENTS = [
  { name: "Lumen Coffee Co.", industry: "F&B" },
  { name: "FinTrack Labs",    industry: "SaaS" },
  { name: "Verdant Naturals", industry: "D2C" },
  { name: "Northsail Yachts", industry: "Luxury" },
  { name: "Kettle & Co.",     industry: "F&B" },
  { name: "Atlas SaaS",       industry: "Tech" },
  { name: "Allbirds",         industry: "Fashion" },
  { name: "Vargam",           industry: "EdTech" },
];

export default function Work() {
  const [filter, setFilter] = useState("All");
  const list = PROJECTS.filter(
    (p) => filter === "All" || p.category === filter || p.tags.includes(filter)
  );

  // Split into two columns for masonry-like layout
  const leftCol = list.filter((_, i) => i % 2 === 0);
  const rightCol = list.filter((_, i) => i % 2 === 1);

  return (
    <div className="ddwork-page" data-testid="work-page">

      {/* ── Sticky Filter Bar ── */}
      <div className="ddwork-filter-bar">
        <div className="container-x">
          <div className="ddwork-filters" data-testid="work-filter-pills">
            {FILTERS.map((f) => (
              <button
                key={f}
                className={`ddwork-filter-btn ${filter === f ? "active" : ""}`}
                onClick={() => setFilter(f)}
                data-testid={`filter-${f.toLowerCase().replace("/", "-")}`}
              >
                {f === "All" ? "All Work" : f}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── Projects Masonry Grid ── */}
      <div className="container-x">
        {list.length === 0 ? (
          <div className="ddwork-empty">No projects found for this filter.</div>
        ) : (
          <div className="ddwork-masonry">
            {/* Left Column */}
            <div className="ddwork-col">
              {leftCol.map((p, i) => (
                <ScrollReveal key={p.slug} delay={i * 100}>
                  <ProjectCard p={p} num={list.indexOf(p) + 1} />
                </ScrollReveal>
              ))}
            </div>

            {/* Right Column — offset downward for stagger */}
            <div className="ddwork-col ddwork-col-right">
              {rightCol.map((p, i) => (
                <ScrollReveal key={p.slug} delay={i * 100 + 50}>
                  <ProjectCard p={p} num={list.indexOf(p) + 1} />
                </ScrollReveal>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ── Trusted Clients Section ── */}
      <section className="ddwork-clients-section">
        <div className="container-x">
          {/* Section label */}
          <div className="ddwork-clients-label">
            <span className="ddwork-clients-line" />
            <span className="ddwork-clients-tag">Sinix Studio® Clients</span>
          </div>

          {/* Client logo grid */}
          <div className="ddwork-clients-grid">
            {CLIENTS.map((c, i) => (
              <ScrollReveal key={c.name} delay={i * 60}>
                <div className="ddwork-client-item">
                  <span className="ddwork-client-name">{c.name}</span>
                  <span className="ddwork-client-industry">{c.industry}</span>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

function ProjectCard({ p, num }) {
  const numStr = String(num).padStart(2, "0");
  return (
    <Link
      to={`/work/${p.slug}`}
      className="ddwork-card"
      data-testid={`proj-card-${p.slug}`}
    >
      {/* Full-bleed image + slide-up overlay */}
      <div className="ddwork-img">
        <img src={p.cover} alt={p.name} loading="lazy" />

        {/* Slide-up panel — tags, description, view project */}
        <div className="ddwork-hover-panel">
          <div className="ddwork-hover-content">
            <p className="ddwork-hover-tags">{p.tags.join(" / ")}</p>
            <p className="ddwork-hover-short">{p.short}</p>
            <span className="ddwork-view-btn">View Project →</span>
          </div>
        </div>
      </div>

      {/* Static info below image — number + name */}
      <div className="ddwork-card-info">
        <span className="ddwork-num">{numStr}</span>
        <div className="ddwork-card-text">
          <h3 className="ddwork-card-name">{p.name}</h3>
        </div>
      </div>
    </Link>
  );
}
